<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    width?: string | number;
    height?: string | number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    width: '20',
    height: '21',
    viewBox: '0 0 20 21',
    color: 'currentcolor',
  }
);
</script>
<template>
  <svg
    :width="props.width"
    :height="props.height"
    :viewBox="props.viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99118 20.4998C6.42137 20.4998 3.12346 18.5935 1.339 15.4995C-0.446333 12.4064 -0.446333 8.5935 1.339 5.50039C3.12346 2.40638 6.42137 0.500055 9.99118 0.500055C11.5482 0.494823 13.0843 0.861964 14.4706 1.57009C14.8148 1.7445 14.9525 2.16572 14.7773 2.5093C14.6031 2.85377 14.1831 2.99156 13.8389 2.81626C12.6496 2.2032 11.3295 1.88402 9.99118 1.88663C7.71175 1.88663 5.52557 2.79271 3.91286 4.40511C2.30091 6.01844 1.39476 8.20637 1.39387 10.4877C1.393 12.7691 2.2983 14.9572 3.9084 16.5713C5.51948 18.1855 7.70551 19.0933 9.98493 19.0951C12.2644 19.0969 14.4512 18.1925 16.065 16.58C17.6779 14.9684 18.5858 12.7812 18.5883 10.5C18.5926 10.4224 18.5926 10.3448 18.5883 10.2672C18.5517 9.88259 18.8349 9.54075 19.22 9.50498C19.6051 9.46836 19.9458 9.75179 19.9824 10.1372V10.5C19.9798 13.1511 18.9263 15.6932 17.053 17.5681C15.1796 19.443 12.6398 20.4973 9.99096 20.5L9.99118 20.4998Z"
      :fill="props.color"
    />
    <path
      d="M9.82389 13.6715C9.64091 13.6741 9.46577 13.6 9.3403 13.4675L4.85126 9.05829C4.5794 8.78533 4.5794 8.34408 4.85126 8.07198C5.12922 7.80339 5.56835 7.80339 5.8463 8.07198L9.83346 12.0067L18.8019 3.17881C19.079 2.91109 19.519 2.91109 19.7961 3.17881C20.068 3.45177 20.068 3.89303 19.7961 4.16512L10.3344 13.4675H10.3353C10.2003 13.6035 10.0156 13.6776 9.82389 13.6715Z"
      :fill="props.color"
    />
  </svg>
</template>
